import React from 'react';
import { TrendingUp } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useMsal, useAccount } from '@azure/msal-react';
import { useGetTicketsPendingCustomerQuery } from '../../../../services/TicketService';
import { countActiveTickets } from '../../utils';
import MetricCard from '../MetricCard';

/**
 * PendingResponseCard - Displays count of tickets pending customer response
 * Excludes closed/cancelled tickets to show only active items needing attention
 */
const PendingResponseCard: React.FC = () => {
  const navigate = useNavigate();
  const { accounts } = useMsal();
  const account = useAccount(accounts[0] || {});
  
  // Get tickets pending customer response
  const { data: pendingTickets = [], isLoading: pendingTicketsLoading } = useGetTicketsPendingCustomerQuery(
    { customerName: account?.name || '' },
    { skip: !account?.name }
  );

  const pendingResponseCount = countActiveTickets(pendingTickets);

  const handleClick = () => {
    navigate('/tickets/pending-response');
  };

  return (
    <MetricCard
      title="Pending Response"
      value={pendingResponseCount}
      icon={TrendingUp}
      color="#ef4444"
      loading={pendingTicketsLoading}
      onClick={handleClick}
      subtitle="Need your attention"
    />
  );
};

export default PendingResponseCard;